<div class="container-fluid text-center" style="max-width: 32% ;margin-bottom: 27%;">
  <h3><b>Change Password</b></h3>
  <div class="row-fluid">
    <div class="span12">
      <div id="sf_admin_container ">
        <div>
          <div *ngIf="invalidConfirmation()" class="alert alert-danger" style="font-size: 13px;">
            The two passwords must be the same.
          </div>
          <form [formGroup]="passwordForm" class="form-horizontal">
            <div class="form-group">
              <label class="col-form-label" for="newPassword">New Password</label>
              <div class="col-form-input">
                <input formControlName="newPassword" id="newPassword" pInputText type="password"/>
                <div *ngIf="submitted && !validLength()" class="show-when-error">At least 8 characters long</div>
                <div
                  *ngIf="submitted && control.newPassword.errors && validLength() && control.newPassword.errors.required"
                  class="show-when-error">Password is required
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="col-form-label " for="confirmNewPassword">Confirm new password</label>
              <div class="col-form-input">
                <input formControlName="confirmNewPassword" id="confirmNewPassword" pInputText type="password"/>
                <div
                  *ngIf="submitted && control.confirmNewPassword.errors && control.confirmNewPassword.errors.required"
                  class="show-when-error">Confirm new password is required
                </div>
              </div>
            </div>
            <app-password-strength (passwordStrength)="passwordValid($event)"
                                   [passwordToCheck]="passwordForm.value.newPassword"></app-password-strength>
            <div class="alert alert-info" style="margin: 1% auto">Security notice : Your password must be at least 8
              characters long and contains at least one number and a special character.
            </div>
            <div class="login-form-actions text-center">
              <div>
                <p-button [disabled]="!passwordIsValid" label="Submit" styleClass="btn btn-primary btn-sm text-right"
                          (click)="onSubmit()"></p-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
